import * as ROUTES from '../routes';


const Navigations = [
    {
        
        title: "Rewards",
        icon: "mdi-medal ",
        to: ROUTES.RANKING,
        mini: false,
        permissions: ['can_view_rewards'],
        subNav: [
          
            {
                title: "rankings",
                to: ROUTES.RANKING,
                icon: 'mdi-wallet-giftcard'
            },  {
                title: "traders",
                to: ROUTES.TOP_TRADERS,
                icon: 'mdi-wallet-giftcard'
            },
            {
                title: "coupons",
                to: ROUTES.COUPONS,
                icon: 'mdi-cards'
            },
            {
                title: "promo",
                to: ROUTES.PROMOTIONS,
                icon: 'mdi-chart-bar'
            },
            
            {
                title: "tutorials",
                to: ROUTES.TUTORIALS,
                icon: 'mdi-video'
            },
             
            {
                title: "banners",
                to: ROUTES.BANNERS,
                icon: 'mdi-watermark'
            },
            {
                title: "bonuses",
                to: ROUTES.BONUSES,
                icon: 'mdi-square-inc-cash'
            },
            
        ],
    },
   
]

export default Navigations